import React from 'react';
import './SkeletonLoader.css';

// Skeleton for AdminUser page
const AdminUserSkeleton = () => {
  return (
    <div className="skeleton-container">
      {/* Header Skeleton */}
      <div className="skeleton-header">
        <div className="skeleton-title"></div>
      </div>

      {/* Profile Section Skeleton */}
      <div className="skeleton-profile-section">
        <div className="skeleton-profile-info">
          <div className="skeleton-profile-avatar">
            <div className="skeleton-profile-image"></div>
          </div>
          <div className="skeleton-profile-details">
            <div className="skeleton-text skeleton-text-large"></div>
            <div className="skeleton-profile-badges">
              <div className="skeleton-badge"></div>
              <div className="skeleton-badge"></div>
              <div className="skeleton-badge"></div>
            </div>
          </div>
        </div>

        <div className="skeleton-referral-section">
          <div className="skeleton-text skeleton-text-medium"></div>
          <div className="skeleton-referral-input-group">
            <div className="skeleton-input skeleton-referral-input"></div>
            <div className="skeleton-referral-actions">
              <div className="skeleton-action-icon"></div>
              <div className="skeleton-action-icon"></div>
              <div className="skeleton-action-icon"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Balance Section Skeleton */}
      <div className="skeleton-balance-section">
        <div className="skeleton-balance-info">
          <div className="skeleton-balance-card">
            <div className="skeleton-text skeleton-text-small"></div>
            <div className="skeleton-text skeleton-text-large"></div>
            <div className="skeleton-text skeleton-text-small"></div>
          </div>
          <div className="skeleton-dm-card">
            <div className="skeleton-text skeleton-text-small"></div>
            <div className="skeleton-text skeleton-text-large"></div>
          </div>
        </div>
        <div className="skeleton-action-buttons">
          <div className="skeleton-button"></div>
          <div className="skeleton-button"></div>
        </div>
      </div>

      {/* Transactions Section Skeleton */}
      <div className="skeleton-transactions-section">
        <div className="skeleton-section-header">
          <div className="skeleton-text skeleton-text-large"></div>
        </div>
        
        <div className="skeleton-filters-container">
          <div className="skeleton-filter-group">
            <div className="skeleton-select"></div>
            <div className="skeleton-select"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="skeleton-table-container">
          <div className="skeleton-table">
            <div className="skeleton-table-header">
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
              <div className="skeleton-table-cell"></div>
            </div>
            
            {/* Table Rows Skeleton */}
            {[...Array(10)].map((_, index) => (
              <div key={index} className="skeleton-table-row">
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                </div>
                <div className="skeleton-table-cell">
                  <div className="skeleton-text skeleton-text-small"></div>
                  <div className="skeleton-button skeleton-button-small"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pagination Skeleton */}
        <div className="skeleton-pagination">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="skeleton-pagination-item"></div>
          ))}
        </div>
      </div>

      {/* Disclaimer Skeleton */}
      <div className="skeleton-disclaimer">
        <div className="skeleton-text skeleton-text-small"></div>
      </div>
    </div>
  );
};

export default AdminUserSkeleton;
